import Icon from 'components/utils/Icon';
import OutsideClickHandler from 'components/utils/OutsideClickHandler';

const ModalMobile = ({ title, children, onClose, width, openModal }) => (
  <div className={openModal ? 'modal-wrapper active' : 'modal-wrapper'}>
    <div className="modal-background">
      {openModal && (
        <OutsideClickHandler onOutsideClick={onClose}>
          <div className={`modal`}>
            <div className="relative">
              <div className="fixed-bar d-f ai-c jc-c">
                <h6>{title}</h6>
                <div onClick={onClose} className="icon-modal">
                  <Icon type="arrow-left" />
                </div>
              </div>
            </div>
            {children}
          </div>
        </OutsideClickHandler>
      )}
    </div>
    <style jsx>
      {`
        :global(body) {
          overflow: ${openModal ? 'hidden!important' : ''};
          padding-right: ${openModal ? '0px!important' : ''};
        }
        .fixed-bar {
          height: 40px;
          border-bottom: solid thin #ccc2;
          margin-bottom: 2px;
        }
        .fixed-bar h6 {
          color: var(--grey-light);
        }
        .modal-wrapper.active {
          position: fixed;
          display: table;
          height: 100vh;
          padding: 0px;
          margin: 0px;
          width: 100%;
          top: 0;
          left: 0;
          z-index: 11;
          background: rgba(0, 0, 0, 0.6);
          opacity: 1;
          z-index: 11111111111111;
        }
        .modal-wrapper {
          display: none;
          height: 0px;
          width: 0px;
        }
        .modal-background {
          width: 100%;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .modal {
          background: var(--background-utils);
          width: ${width};
          display: flex;
          padding: var(--margin-md);
          flex-direction: column;
          box-shadow: var(--shadow-light);
          position: absolute;
          bottom: 0px;
          left: 0px;
          overflow: scroll;
          max-height: 100%;
        }
        .modal .icon-modal {
          cursor: pointer;
          z-index: 16;
          position: absolute;
          left: 0;
        }
        .modal :global(.icon-modal .icon) {
          color: var(--grey-light);
          font-size: 30px;
        }
      `}
    </style>
  </div>
);

export default ModalMobile;
